<template>
	<div class="article-box">
		<div class="banner-box">
			<banner></banner>
		</div>
		<div class="headline-box white-bg">
			<div class="headline-news">
				<!--文字-->
				<p>启帆数字作为优质的生活服务平台，业务覆盖技术、设计、汽车、本地生活服务等各个领域。</p>
				<p>在用户服务层面，不仅是一个信息交互的平台，更是一站式的生活服务平台，同时也逐步为商家建立全方位的市场营销解决方案。</p>
				<p>启帆数字希望成为了中国全面服务本地商户与用户的线上商业服务平台。</p>
			</div>
		</div>
		<div class="blank clear"></div>
		<div class="blank clear"></div>

		<div>
			<h2 id="qyfw">企业服务</h2>
		</div>
		<div class="news box white-bg tab-num03" v-for="item in info">
			<div class="gd-box">
				<ul class="id-tab">
					<li class="tab-current">{{ item.head }}</li>
				</ul>
			</div>
			<div class="id-tab-content">
				<section class="tab-box">
					<div class="news-new">
						<ul>
							<li v-for="i in item.list">
								<section>
									<router-link :to="{path: '/article', query: {id: item.id, cid: i.id}}"
										class="news-new-pic">
										<img :src="i.imgUrl" />
									</router-link>
									<h2>
										<router-link
											:to="{path: '/article', query: {id: item.id, cid: i.id}}">{{ i.title }}</router-link>
									</h2>
									<p>{{ i.desc }}</p>
								</section>
							</li>
						</ul>
					</div>
				</section>
			</div>
		</div>
		<div class="clear blank"></div>
		<div class="blank clear"></div>

		<div>
			<h2 id="essc">二手市场</h2>
		</div>
		<div class="videos box white-bg tab-num04">
			<div class="gd-box">
				<ul class="id-tab">
					<li class="tab-current">品牌手机</li>
				</ul>
			</div>
			<div class="id-tab-content">
				<section class="tab-box">
					<div class="videos-list">
						<ul>
							<li v-for="i in phoneList" :key="i.title">
								<router-link :to="{path: '/article1', query: {type: 'essc', id: i.id}}">
									<i>
										<img :src="require('@/assets/images/'+i.img)"></img>
									</i>
									<h2>{{ i.title }}</h2>
									<p>
										<b class="datetime">{{ i.time }}</b>
										<span class="view-num">{{ i.num }}人在看</span>
									</p>
								</router-link>
							</li>
						</ul>
					</div>
				</section>
			</div>
		</div>
		<div class="blank clear"></div>
		<div class="blank clear"></div>
		<div class="videos box white-bg tab-num04">
			<div class="gd-box">
				<ul class="id-tab">
					<li class="tab-current">二手电脑</li>
				</ul>
			</div>
			<div class="id-tab-content">
				<section class="tab-box">
					<div class="videos-list">
						<ul>
							<li v-for="i in esddList" :key="i.title">
								<router-link :to="{path: '/article1', query: {type: 'esdd', id: i.id}}">
									<i>
										<img :src="require('@/assets/images/'+i.img)"></img>
									</i>
									<h2>{{ i.title }}</h2>
									<p>
										<b class="datetime">{{ i.time }}</b>
										<span class="view-num">{{ i.num }}人在看</span>
									</p>
								</router-link>
							</li>
						</ul>
					</div>
				</section>
			</div>
		</div>
		<div class="blank clear"></div>
		<div class="blank clear"></div>
		<div class="videos box white-bg tab-num04">
			<div class="gd-box">
				<ul class="id-tab">
					<li class="tab-current">办公用品</li>
				</ul>
			</div>
			<div class="id-tab-content">
				<section class="tab-box">
					<div class="videos-list">
						<ul>
							<li v-for="i in bgypList" :key="i.title">
								<router-link :to="{path: '/article1', query: {type: 'bgyp', id: i.id}}">
									<i>
										<img :src="require('@/assets/images/'+i.img)"></img>
									</i>
									<h2>{{ i.title }}</h2>
									<p>
										<b class="datetime">{{ i.time }}</b>
										<span class="view-num">{{ i.num }}人在看</span>
									</p>
								</router-link>
							</li>
						</ul>
					</div>
				</section>
			</div>
		</div>
		<div class="blank clear"></div>
		<div class="blank clear"></div>
		<div class="videos box white-bg tab-num04">
			<div class="gd-box">
				<ul class="id-tab">
					<li class="tab-current">电子产品</li>
				</ul>
			</div>
			<div class="id-tab-content">
				<section class="tab-box">
					<div class="videos-list">
						<ul>
							<li v-for="i in dzcpList" :key="i.title">
								<router-link :to="{path: '/article1', query: {type: 'dzcp', id: i.id}}">
									<i>
										<img :src="require('@/assets/images/'+i.img)"></img>
									</i>
									<h2>{{ i.title }}</h2>
									<p>
										<b class="datetime">{{ i.time }}</b>
										<span class="view-num">{{ i.num }}人在看</span>
									</p>
								</router-link>
							</li>
						</ul>
					</div>
				</section>
			</div>
		</div>
		<div class="blank clear"></div>
		<div class="blank clear"></div>
		<div>
			<h2 id="jypx">休闲娱乐</h2>
		</div>
		<div class="videos box white-bg tab-num04">
			<div class="gd-box">
				<ul class="id-tab">
					<li class="tab-current">户外</li>
				</ul>
			</div>
			<div class="id-tab-content">
				<section class="tab-box">
					<div class="videos-list">
						<ul>
							<li v-for="i in jypxList" :key="i.title">
								<router-link :to="{path: '/article1', query: {type: 'jypx', id: i.id}}">
									<i>
										<img style="height: 100%;" :src="require('@/assets/images/'+i.img)">
									</i>
									<h2>{{ i.title }}</h2>
									<p><b class="datetime">{{ i.time }}</b><span class="view-num">{{ i.num }}人在看</span>
									</p>
								</router-link>
							</li>
						</ul>
					</div>
				</section>
			</div>
		</div>
		<div class="blank clear"></div>
		<div class="blank clear"></div>
	</div>
</template>

<script>
	import Banner from '../components/Banner'
	import info from '../../public/test/info1.json'
	// 引入 json 数据文件
	import data from '../assets/json/data.json';

	export default {
		name: 'Main',
		components: {
			Banner
		},
		data() {
			return {
				info,
				// 二手市场手机列表
				phoneList: data.phoneList,
				// 招商加盟列表
				zsjmList: data.zsjmList,
				// 休闲娱乐列表
				jypxList: data.jypxList,
				// 二手电脑列表
				esddList: data.esddList,
				// 办公用品列表
				bgypList: data.bgypList,
				// 电子产品列表
				dzcpList: data.dzcpList,
			}
		}
	}
</script>
